export const OnPageLoad_POST = `/customerportal/mainhome/v1/page_load`;
export const GET_Countries = `/customerportal/common/v1/getcountries`;
export const POST_PRODUCT_INFO=`/customerportal/common/v1/getproductinfo`;
export const POST_PRODUCT_LOAD = `/customerportal/product/v1/page_load`;
export const POST_BIND_APP_VER = `/customerportal/createcase/v1/BindOperatingSystemVerion`
export const POST_BIND_APP_VER2 = `/customerportal/createcase/v1/BindApplicationVersionL2`
export const POST_CALL_IS_SERVICE = `/customerportal/common/v1/callisservice`
export const POST_CREATE_CASE_LOAD = `/customerportal/createcase/v1/Page_load`;
export const POST_EDIT_CASE_LOAD = `/customerportal/Editcase/v1/Page_load`;
export const POST_EDIT_CASE_GETTERADICDPRODUCTID= `/customerportal/common/v1/getteradiciproductid`;
export const POST_C_AND_W_PAGELOAD = `/customerportal/contractandwarranty/v1/page_load`
export const POST_btnProductSearch_Click = `/customerportal/contractandwarranty/v1/btnProductSearch_Click`
export const POST_PRODUCT_LOAD_MATCHING_CASE = `/customerportal/matchingcase/v1/page_load`
export const GET_Display_NonSerializedProducts = `/customerportal/mainhome/v1/Display_NonSerializedProducts`
export const POST_RetrieveContactDetailsOnChange = '/customerportal/createcase/v1/RetrieveContactDetailsOnChange'
export const POST_validateaddress = '/customerportal/common/v1/validateaddress'
export const POST_CREATE_CASE ='/customerportal/createcase/v1/OnSubmit';
export const Get_PolySN ='/customerportal/mainhome/v1/Get_PolySN';
export const GET_ATTACHMENT_FILE_DOWNLOAD = '/customerportal/Editcase/v1/attachfiledownload/'
export const POST_UPDATE_CASE = '/customerportal/Editcase/v1/Update_CaseNote'
export const POST_VALIDATE_DATE = "/customerportal/Editcase/v1/ValidateDate";
export const POST_UPDATE_CUSTOMER_AVAILABILITY = '/customerportal/Editcase/v1/CustomerAvailability'
export const POST_CLOSE_CASE = '/customerportal/Editcase/v1/Close_Case'
export const POST_PAGE_LOAD_EDIT_CASE = '/customerportal/Editcase/v1/Page_load'
export const POST_PRODUCT_INFO_EDIT_CASE = '/customerportal/common/v1/getproductinfo'
export const POST_FAVOURITES ='/customerportal/common/v1/saveuserfavourites'
export const POST_ADDPRODUCT_WARRANTY = '/customerportal/contractandwarranty/v1/btnAddProduct_Click';
export const POST_INITIATE_CHAT_LOAD = `/customerportal/chat/v1/page_load` ;
export const POST_GET_MATCH_COUNT = `/customerportal/matchingcase/v1/GetMatchedCasesCount` ;
export const POST_MATCH_PAGE_LOAD = `/customerportal/matchingcase/v1/page_load`;
export const POST_PROFILE_PAGE_LOAD = `/customerportal/profile/v1/Page_load`;
export const POST_UPLOAD_ATTACHMENTS = `/customerportal/createcase/v1/fileupload`;
export const POST_GETMETHONECACHETOKEN = `/customerportal/chat/v1/GetMethoneCacheToken` ;
export const POST_GETMETHONECHATJWTTOKEN = `/customerportal/chat/v1/GetMethoneChatJWTToken`;
export const POST_CONTACT_SAVE = `/customerportal/profile/v1/contact_save`;
export const POST_PROFILE_ADD_CONTACT = `/customerportal/profile/v1/AddContact`;
export const POST_CALLTO_CCLS = `/customerportal/Editcase/v1/CallTo_CCLS`;
export const POST_CASE_SEARCH =  `/customerportal/mainhome/v1/searchcases`
export const POST_DunsNumberDropDownShippingAddres_SelectedIndexChanged = `/customerportal/profile/v1/dunsNumberDropDownShippingAddres_selectedindexchanged`;
export const POST_ACCOUNT_SAVE =`/customerportal/profile/v1/account_save`
export const POST_SEARCH_SAVED_ADDRESSs =`/customerportal/profile/v1/SearchSavedAddres`
export const POST_SELECTED_CONTACT=`/customerportal/profile/v1/GetSelectedContact`
export const POST_CONTACT_EDIT = `/customerportal/profile/v1/contact_edit`
export const POST_ADD_USER = `/customerportal/profile/v1/SubmitAddUser_Click`
export const POST_ADD_OR_REMOVE = `/customerportal/profile/v1/addorremoverole`;
export const POST_CHANGE_SELECTION = `/customerportal/profile/v1/changeselection`;
export const GET_TERADICI_PRODUCT_ID = `/customerportal/common/v1/getteradiciproductid`;
export const POST_UPLOAD_LOG_ATTACHMENTS = `/customerportal/createcase/v1/TeradeciFileUpload`;
export const POST_ROW_DELETE = `/customerportal/contractandwarranty/v1/gvlinkedsupportagreements_RowDeleting`
export const POST_ROW_UPDATE = `/customerportal/contractandwarranty/v1/gvlinkedsupportagreements_RowUpdating`

export const POST_SHIPPING_ADDRESS_CHANGE = `/customerportal/createcase/v1/RetrieveShippingAddressOnChange`
export const POST_PROFILE_ACCOUNT_NAME_CHANGE = `/customerportal/profile/v1/dunsNumberDropDown_selectedindexchanged`



  // https://hpcdaxcan.hpcloud.hp.com/mycrmportal/api/customerportal/common/v1/getteradiciproductid


